<template>
  <Layout>
    <q-card
      bordered
      flat
      class="q-pa-md"
      style="width:100%; border-radius: 10px"
    >
      <h5 style="text-align:center">Create Accident Report</h5>
      <q-form
        @submit.prevent="onSubmit"
        @reset="onReset"
        enctype="multipart/form-data"
      >
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-6 col-xs-12">
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.rental_agreement_number"
                  label="Rental Agreement Number *"
                  lazy-rules
                  :rules="[
                    (val) =>
                      (val && val.length > 0) ||
                      'Please type your rental agreement number',
                  ]"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.renter_name"
                  label="Renter Name"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.renter_phone_number"
                  mask="(###)-###-####"
                  label="Renter Phone Number"
                >
                  <template v-slot:prepend>
                    <q-icon
                      name="fas fa-phone"
                      size="16px"
                      color="grey-7"
                    ></q-icon>
                  </template>
                </q-input>
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  type="email"
                  v-model="report.renter_email_address"
                  label="Renter Email Address *"
                  lazy-rules
                  :rules="[
                    isValidEmail,
                    (val) =>
                      (val && val.length > 0) || 'Please type email address',
                  ]"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.renter_driver_license_number_and_state"
                  label="Renter Driver License Number and State"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  outlined
                  v-model="report.claim_report_to"
                  type="email"
                  label="Claim Report To *"
                  dense
                  class="customTextColor"
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  lazy-rules
                  :rules="[
                    isValidEmail,
                    (val) =>
                      (val && val.length > 0) || 'Please type email address',
                  ]"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  v-model="report.accident_date"
                  label="Accident Date *"
                  label-color="grey-7"
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  mask="##/##/####"
                  lazy-rules
                  :rules="[
                    (val) =>
                      (val && val.length > 0) || 'Please type accident date',
                  ]"
                >
                  <template v-slot:append>
                    <q-icon name="fas fa-calendar" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qDateProxy1"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-date
                          v-model="report.accident_date"
                          mask="MM/DD/YYYY"
                        >
                          <div class="row items-center justify-end">
                            <q-btn
                              v-close-popup
                              label="Close"
                              color="primary"
                              flat
                            />
                          </div>
                        </q-date>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.police_report_number_and_police_station"
                  label="Police Report Number and Police Station"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.accident_location_address"
                  label="Accident Location Address"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.driver_name"
                  label="Other Party Driver Name"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  mask="(###)-###-####"
                  v-model="report.driver_phone_number"
                  label="Other Party Driver Phone Number"
                >
                  <template v-slot:prepend>
                    <q-icon
                      name="fas fa-phone"
                      size="16px"
                      color="grey-7"
                    ></q-icon>
                  </template>
                </q-input>
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.driver_email_address"
                  label="Other Party Driver Email Address"
                />
              </div>
              <div class="q-mb-md">
                <q-input
                  dense
                  class="customTextColor"
                  outlined
                  color="grey-7"
                  hide-bottom-space
                  label-color="grey-7"
                  v-model="report.driver_licence_number_and_station"
                  label="Other Party Driver Licence Number and Station"
                />
              </div>
              <div>
                <div class="file-input">
                  <input
                    ref="fileInput"
                    accept=".jpg, .jpeg, .png"
                    @change="selectFiles"
                    type="file"
                    multiple
                    class="file"
                  />
                  <label for="file">
                    <q-icon
                      class="q-mx-sm"
                      name="fas fa-upload"
                      size="20px"
                      color="grey-7"
                    ></q-icon>
                    Accident Photos
                    <span class="file-name"></span
                  ></label>
                </div>
                <div v-if="!isErrorLen">
                  <span v-for="(file, index) in files" :key="index">
                    {{ file.name }}
                  </span>
                </div>
                <span v-else class="text-red-5"
                  >Files length must be less than 6</span
                >
                <br />
                <span v-if="isErrorSize" class="text-red-5"
                  >Files size must be equal to or less than 2MB</span
                >
              </div>
            </div>

            <div>
              <q-btn label="Submit" type="submit" color="primary" />
              <q-btn
                label="Reset"
                type="reset"
                color="primary"
                flat
                class="q-ml-sm"
              />
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </Layout>
</template>

<script>
import Layout from "../components/Layout";
import axios from "../axios/index";
import { date } from "quasar";
export default {
  components: {
    Layout,
  },
  data() {
    return {
      report: {
        rental_agreement_number: null, // required
        renter_name: null,
        renter_phone_number: null,
        renter_email_address: null, // required
        renter_driver_license_number_and_state: null,
        claim_report_to: null, // required
        accident_date: null, // required
        police_report_number_and_police_station: null,
        accident_location_address: null,
        driver_name: null,
        driver_phone_number: null,
        driver_email_address: null,
        driver_licence_number_and_station: null,
        accident_photos: null,
      },
      files: [],
      isErrorSize: null,
      isErrorLen: null,
    };
  },
  methods: {
    isValidEmail(val) {
      const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      if (val) return emailPattern.test(val) || "Invalid email";
    },
    isValidDate(val) {
      if (val) return date.isValid(val) || "Invalid date";
    },
    async onSubmit() {
      const formData = new FormData();
      const fullTime = this.report.accident_date.split("/");
      const formatdate = `${fullTime[2]}-${fullTime[0]}-${fullTime[1]}`;
      formData.append(
        "rental_agreement_number",
        this.report.rental_agreement_number
      );
      formData.append("renter_email_address", this.report.renter_email_address);
      formData.append("claim_report_to", this.report.claim_report_to);
      formData.append("accident_date", formatdate);

      for (let i = 0; i < this.files.length; i++) {
        formData.append("accident_photos[]", this.files[i]);
      }
      if (this.isErrorSize || this.isErrorLen) {
        return;
      }
      this.$q.loading.show();
      try {
        const res = await axios.post("/forms/renter-accident-report", formData);
        this.$q.loading.hide();
        this.$q.notify({
          color: "positive",
          textColor: "white",
          message: res.data.message,
          position: "top",
          timeout: 3000,
        });
      } catch (error) {
        this.$q.loading.hide();
        const errors = error.response?.data?.errors || "Something went wrong";
        let message = "";
        function errorHandler(obj) {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key];
              if (Array.isArray(element)) {
                message = element[0];
              } else if (typeof element === "object") {
                errorHandler(element);
              } else {
                message = element;
              }
            }
          }
        }
        if (error.response?.data?.code === 404) {
          message = error.response?.data?.message;
        } else if (error.response?.data?.code === 422) {
          errorHandler(errors);
        } else if (error.response?.data?.code === 413) {
          message = "Files size must be equal to or less than 2MB";
        } else if (error.response?.data?.code === 500) {
          message = error.response?.data?.message;
        }

        this.$q.notify({
          message,
          timeout: 3000,
          position: "top-right",
          progress: true,
          type: "negative",
        });
      }
    },
    onReset() {
      this.report = {
        rental_agreement_number: null, // required
        renter_name: null,
        renter_phone_number: null,
        renter_email_address: null, // required
        renter_driver_license_number_and_state: null,
        claim_report_to: null, // required
        accident_date: null, // required
        police_report_number_and_police_station: null,
        accident_location_address: null,
        driver_name: null,
        driver_phone_number: null,
        driver_email_address: null,
        driver_licence_number_and_station: null,
        accident_photos: null,
      };
    },
    selectFiles() {
      this.files = this.$refs.fileInput.files;
      this.isErrorLen = this.files.length > 5 ? true : false;
      //this.files && this.calculateFileSize2(Object.values(this.files));
      this.isErrorSize = Object.values(this.files).some(
        (file) => !this.calculateFileSize(file)
      );
    },
    calculateFileSize(file) {
      const fileSizeInBytes = file.size;
      const fileSizeInKb = fileSizeInBytes / 1024;
      const fileSizeInMb = fileSizeInKb / 1024;
      return fileSizeInMb <= 2 ? true : false;
    },
    // calculateFileSize2(files) {
    //   for (let i = 0; i < files.length; i++) {
    //     const fileSizeInBytes = files[i].size;
    //     const fileSizeInKb = fileSizeInBytes / 1024;
    //     const fileSizeInMb = fileSizeInKb / 1024;
    //     if (fileSizeInMb > 2) {
    //       return false;
    //     }
    //     return true;
    //   }
    // },
  },
};
</script>

<style scoped>
.file-input {
  position: relative;
  height: 40px;
  width: 100%;
  cursor: pointer;
}
.file {
  opacity: 0;
  width: 100%;
  height: 40px;
  left: 0;
  top: 0;
  position: absolute;
  z-index: 1000;
  outline: none;
  cursor: pointer;
}
.file-input label {
  display: block;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-out;
  cursor: pointer;
}
input:hover + label,
input:focus + label {
  transform: scale(1.02);
  cursor: pointer;
}
input:focus + label {
  outline: 1px solid #bdbdbd;
  outline: -webkit-focus-ring-color auto 1px;
  cursor: pointer;
}
</style>
